export const environment = {
  production: true,
  qrUrl: 'https://dev-pay.qwiko.app',
  appUrl: 'https://dev-pay.qwikoapps.com',
  baseUrl: 'https://dev-pay.qwikoapps.com',
  apiUrl: 'https://dev-api.qwikoapps.com',
  authUrl: 'https://dev-auth.qwikoapps.com/auth',
  firebase: {
    apiKey: 'AIzaSyDs3mheNJoLZPR5gxkguOQCVQhzkgHWH28',
    authDomain: 'qwikoappsdev.firebaseapp.com',
    projectId: 'qwikoappsdev',
    storageBucket: 'qwikoappsdev.firebasestorage.app',
    messagingSenderId: '920109618387',
    appId: '1:920109618387:web:b8d236321eb914ebd6b026',
    measurementId: 'G-B9RCJB43EW',
  },
  recaptcha: {
    sitekey: '6LdFNNkqAAAAAOF25IU0IbTaPPUnnTCAsYedCmGR',
  },
  encryptionKey: 'wdzhgwfVG41P1sTlOx5eO+rTGzX5bNEZZKXgKgbukvk=',
  useEmulators: false,
};
